<template>
    <div>
        <div class="balanca-container">
            <Header v-once class="header" :showCartButton="true"></Header>
            <img class="background-image" :src="getImage() || balancascreen"/>
            <div class="weighed-container" :style="getRowsHeight()" v-if="moreThanOneWeighetable">
                <div class="weighed-item-container" v-for="(witem, key) in weighed" :key="key" @click="addProdOnCart(witem)">
                    <div class="weighed-item">
                        <img :src="getImagesURL(witem, 'productImages') || junk" :alt="witem.productName">
                        <span v-text="getProductLanguage(witem, 'productName')"></span>
                    </div>
                </div>
            </div>
        </div>
        <GoMenuModal v-if="showGoMenu"></GoMenuModal>
    </div>
</template>

<script>
import Util from '@/assets/libs/util'
import CartController from '@/assets/controllers/CartController'
import BalancaController from '@/assets/controllers/BalancaController'
import LocaleController from '@/assets/controllers/LocaleController'
import Header from '@/components/Header'
import GoMenuModal from '@/components/GoMenuModal'
import DifferentiatedPricesController from '@/assets/controllers/DifferentiatedPricesController'
export default {
    name: 'BalancaScreen',
    components: {
        Header,
        GoMenuModal
    },
    data () {
        return {
            oneItem: false,
            curProd: null,
            moreThanOneWeighetable: false,
            readWeight: null,
            weighed: Util.getLocalConfigs('weighed'),
            interval: null,
            hybridMode: Util.isHybridMode(),
            showGoMenu: false,
            junk: require('../../static/icons/junk-icon.png'),
            balancascreen: require('../../static/icons/balancascreen.jpg')
        }
    },
    methods: {
        getString: function (key) {
            return LocaleController.getString(key)
        },
        getImagesURL: function (prod, prop) {
            let url = Util.getLocalConfigs('urlIMGOdhenInterface')
            let uri = (prod[prop] && prod[prop].small)
            return uri && (url + uri)
        },
        getRowsHeight: function () {
            let style = 'grid-template-rows: '
            for (let i = 0; i < this.weighed.length; i++) {
                style = style + 100 / Math.ceil(this.weighed.length / 2) + '% '
            }
            if (this.weighed.length > 2) {
                style = style + '; margin: 0'
            }
            return style + ';'
        },
        addProdOnCart: function (item) {
            item.quantity = this.readWeight
            item.productScale = true
            let diffPrice = DifferentiatedPricesController.getDiffPrice(item.productCode, false, item)
            if (diffPrice) {
                item.price = diffPrice
            }
            CartController.addToCart(CartController.fixProdForCart(item))
            if (this.hybridMode) {
                this.showGoMenu = true
            } else {
                this.$router.push('checkout')
            }
        },
        getImage: function () {
            return Util.getConfigImage('balancascreen')
        },
        startWeight: async function (config) {
            let cont = 60
            await BalancaController.openBalancaPort()
            this.interval = setInterval(async () => {
                let response = await BalancaController.getWeight()
                let hasValidWeight = response && response.result && !response.result.error && response.result.peso && response.result.peso > 0
                if (hasValidWeight) {
                    this.readWeight = response.result.peso
                }
                if (this.readWeight && this.readWeight !== 0) {
                    if (config.length > 1) {
                        this.moreThanOneWeighetable = true
                    } else {
                        this.moreThanOneWeighetable = false
                        this.addProdOnCart(config[0])
                    }
                    await BalancaController.closeBalancaPort()
                    clearInterval(this.interval)
                }

                if (cont === 0) {
                    await BalancaController.closeBalancaPort()
                    clearInterval(this.interval)
                }
                cont--
            }, 2000)
        },
        getProductLanguage: function (product, index) {
            return LocaleController.getIndexLanguages(product, index)
        }
    },
    mounted () {
        let config = Util.getLocalConfigs('weighed')
        if (!(config && config.length)) {
            let infoMessage = this.getString('nao_ha_produto_padrao_pesagem_parametrizado')
            Util.showInfoModal(infoMessage)
            return false
        }
        this.startWeight(config)
    },
    beforeDestroy () {
        clearInterval(this.interval)
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import (reference) url("../assets/common.less");
.overlay {
    .full;
    background: black;
    opacity: .4;
}
.balanca-container {
    .full;
    position: absolute;
    .background-image{
        width: 100%;
        max-height: calc(100vh - 240px);
        object-fit: cover;
    }
    .weighed-container {
        z-index: 1;
        overflow: hidden;
        position: absolute;
        background: white;
        top: 180px;
        left: 0;right: 0;
        display: grid;
        padding: 0 15px;
        grid-template-columns: calc(50% - 7.5px) calc(50% - 7.5px);
        grid-column-gap: 15px;
        height: calc(100% - 180px);
        .weighed-item-container {
            display: flex;
            margin: -180px 0 0 0;
            flex-direction: column;
            flex-wrap: nowrap;
            align-content: center;
            justify-content: center;
            align-items: stretch;
            position: relative;
            &:only-child {
                .full;
                    position: absolute;
                }
            .weighed-item {
                position: relative;
                display: grid;
                grid-template-rows: 300px 100px;
                justify-content: center;
                align-items: center;
                box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.33);
                border-radius: 15px;
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    grid-row: 1;
                }
                span {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    background: @primary-color;
                    color: var(--categorie-font-color);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    text-align: center;
                    font-size: 3rem;
                    border-bottom-right-radius: 15px;
                    border-bottom-left-radius: 15px;
                    height: 100px;
                    grid-row: 2;
                }
            }
        }
    }
}
@media (min-width: 699px) and (max-width: 1025px) { //@tablet
    .balanca-container {
        .background-image {
            max-height: calc(100vh - 190px);
        }
        .weighed-container {
            .weighed-item-container {
                .weighed-item {
                    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.33);
                    border-radius: 10px;
                    grid-template-rows: 250px 80px;
                    span {
                        font-size: 2rem;
                        height: 100%;
                        grid-row: 2;
                        border-bottom-right-radius: 10px;
                        border-bottom-left-radius: 10px;
                    }
                }
            }
        }
    }
}

@media (max-width: 698px) { // Gertec SK210
    .balanca-container {
        .background-image {
            max-height: calc(100vh - 80px);
        }
        .weighed-container {
            top: 50px;
            height: calc(100% - 50px);
            .weighed-item-container {
                margin: -50px 0 0 0;
                .weighed-item {
                    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.33);
                    border-radius: 10px;
                    grid-template-rows: 100px 40px;
                    span {
                        font-size: 16px;
                        height: 100%;
                        grid-row: 2;
                        border-bottom-right-radius: 5px;
                        border-bottom-left-radius: 5px;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/BalancaScreen.vue